
<div class="form-group inline-form">
  <span class="input-group-text">$</span>
  <input type="number" bind:value class="form-control" id="cycleBudgetInput"
    placeholder={placeholder} required />
  <div class="input-group-append">
    <span class="input-group-text">.00</span>
  </div>
</div>

<script>
  export let value
  export let placeholder = null
</script>